export default __webpack_public_path__ + "static/media/owncloud.b0e5871a.svg";